import { AvatarGroupComponent, avatarGroupTemplate } from './AvatarGroup';
import styles from './AvatarGroup.styles.scss';
export const avatarGroupDefinition = {
    template: avatarGroupTemplate,
    styles,
};
export const chameleonAvatarGroup = AvatarGroupComponent.compose(Object.assign(Object.assign({}, avatarGroupDefinition), { baseName: 'avatar-group' }));
